// Virtual classroom (live lesson) strings: video controls, tooltips, banners.
const dict = {
  uk: {
    roleTeacher: 'Вчитель',
    roleStudent: 'Учень',
    studentDefault: 'Студент',
    lessonDefault: 'Урок',
    checkPending: 'Відповіді учня ще не отримано. Зачекайте секунду і натисніть ще раз.',
    errorTitle: 'Помилка',
    errRecipient: 'Не вдалося визначити отримувача повідомлення.',
    errSendMessage: 'Не вдалося відправити повідомлення. Спробуйте ще раз.',
    errSaveReport: 'Не вдалося зберегти звіт. Спробуй ще раз.',
    showVideoAria: 'Показати відео',
    collapseVideoAria: 'Згорнути відео',
    prevParticipantAria: 'Попередній учасник',
    nextParticipantAria: 'Наступний учасник',
    awaitingPresentation: 'Очікування презентації',
    awaitingPresentationSub: 'Вчитель скоро поділиться матеріалами',
    presentationUnavailable: 'Презентація недоступна',
    presentationUnavailableSub: 'Для цього уроку вчитель ще не обрав презентацію',
    loadingSlide: 'Завантаження слайду...',
    loadingPresentation: 'Завантаження презентації...',
    presentationLoadError: 'Не вдалося завантажити презентацію',
    presentationLoadErrorSub: 'Спробуйте оновити сторінку. Якщо не допомагає — напишіть адміну.',
    refresh: 'Оновити',
    presentationNotSelected: 'Презентація не обрана',
    presentationNotSelectedSub: 'До цього уроку не приваʼязана презентація',
    slideIndicator: 'Слайд {{current}} / {{total}}',
    timeUp: 'Час вийшов!',
    stopTimer: 'Зупинити таймер',
    drag: 'Перетягніть',
    inputPlaceholder: 'Введіть відповідь...',
    videoAlt: 'Відео',
    audioAlt: 'Аудіо',
    imageAlt: 'Зображення',
    colorTooltip: 'Колір {{color}}',
    thicknessTooltip: 'Товщина {{size}}',
    micUnavailable: 'Мікрофон недоступний',
    cameraUnavailable: 'Камера недоступна',
    zoom: 'Лупа',
    pencil: 'Олівець',
    eraser: 'Стирачка',
    stopSharing: 'Зупинити показ',
    sharePresentation: 'Поділитися презентацією',
    noPresentationAttached: 'У цьому уроці немає прив\'язаної презентації',
    stop: 'Зупинити',
    show: 'Показати',
    pointer: 'Указка',
    clearAllDrawings: 'Очистити всі малюнки',
    timer: 'Таймер',
    checkAllExercises: 'Перевірити всі вправи на слайді',
    noExercisesToCheck: 'На цьому слайді немає вправ для перевірки',
    check: 'Перевірити',
    slideNotesTooltip: 'Нотатки до слайда (видно лише вам)',
    slideNotesTitle: 'Нотатки (видно лише вам)',
    notes: 'Нотатки',
    chat: 'Чат',
    endLessonAria: 'Завершити урок',
    endLesson: 'Завершити урок',
    closeChat: 'Закрити чат',
    countingStars: 'Підраховуємо зірочки…',
    liveVocab: {
      buttonTitle: 'Додати слово в словник учня',
      title: 'Додати слово в словник',
      subtitle: 'Слово зʼявиться у домашньому завданні цього учня після уроку.',
      studentLabel: 'Учень',
      wordLabel: 'Слово (EN)',
      translationLabel: 'Переклад',
      translationPlaceholder: 'яблуко',
      transcriptionLabel: 'Транскрипція (за бажанням)',
      imageLabel: 'Картинка (за бажанням)',
      uploadImage: 'Завантажити',
      uploading: 'Завантаження…',
      pickSticker: 'Обрати зі стікерів',
      changeSticker: 'Змінити зображення',
      imageTooLarge: 'Файл більше 5 МБ',
      uploadFailed: 'Не вдалося завантажити картинку',
      addToHomework: 'Додати в дз',
      cancel: 'Скасувати',
      added: 'Слово додано в словник {{name}}',
      failed: 'Не вдалося додати слово',
      student: 'учня',
    },
  },
  en: {
    roleTeacher: 'Teacher',
    roleStudent: 'Student',
    studentDefault: 'Student',
    lessonDefault: 'Lesson',
    checkPending: "Student's answers haven't arrived yet. Wait a moment and try again.",
    errorTitle: 'Error',
    errRecipient: 'Unable to determine the message recipient.',
    errSendMessage: 'Failed to send the message. Please try again.',
    errSaveReport: 'Failed to save the report. Please try again.',
    showVideoAria: 'Show video',
    collapseVideoAria: 'Collapse video',
    prevParticipantAria: 'Previous participant',
    nextParticipantAria: 'Next participant',
    awaitingPresentation: 'Waiting for presentation',
    awaitingPresentationSub: 'The teacher will share materials soon',
    presentationUnavailable: 'Presentation unavailable',
    presentationUnavailableSub: 'The teacher has not selected a presentation for this lesson yet',
    loadingSlide: 'Loading slide...',
    loadingPresentation: 'Loading presentation...',
    presentationLoadError: 'Failed to load presentation',
    presentationLoadErrorSub: 'Try refreshing the page. If it does not help, contact an admin.',
    refresh: 'Refresh',
    presentationNotSelected: 'No presentation selected',
    presentationNotSelectedSub: 'No presentation is attached to this lesson',
    slideIndicator: 'Slide {{current}} / {{total}}',
    timeUp: "Time's up!",
    stopTimer: 'Stop timer',
    drag: 'Drag',
    inputPlaceholder: 'Enter your answer...',
    videoAlt: 'Video',
    audioAlt: 'Audio',
    imageAlt: 'Image',
    colorTooltip: 'Color {{color}}',
    thicknessTooltip: 'Thickness {{size}}',
    micUnavailable: 'Microphone unavailable',
    cameraUnavailable: 'Camera unavailable',
    zoom: 'Zoom',
    pencil: 'Pencil',
    eraser: 'Eraser',
    stopSharing: 'Stop sharing',
    sharePresentation: 'Share presentation',
    noPresentationAttached: 'No presentation attached to this lesson',
    stop: 'Stop',
    show: 'Show',
    pointer: 'Pointer',
    clearAllDrawings: 'Clear all drawings',
    timer: 'Timer',
    checkAllExercises: 'Check all exercises on the slide',
    noExercisesToCheck: 'No exercises to check on this slide',
    check: 'Check',
    slideNotesTooltip: 'Slide notes (visible only to you)',
    slideNotesTitle: 'Notes (visible only to you)',
    notes: 'Notes',
    chat: 'Chat',
    endLessonAria: 'End lesson',
    endLesson: 'End lesson',
    closeChat: 'Close chat',
    countingStars: 'Counting stars…',
    liveVocab: {
      buttonTitle: "Add a word to student's dictionary",
      title: 'Add word to dictionary',
      subtitle: "The word will appear in this student's homework after the lesson.",
      studentLabel: 'Student',
      wordLabel: 'Word (EN)',
      translationLabel: 'Translation',
      translationPlaceholder: 'apple',
      transcriptionLabel: 'Transcription (optional)',
      imageLabel: 'Image (optional)',
      uploadImage: 'Upload',
      uploading: 'Uploading…',
      pickSticker: 'Pick a sticker',
      changeSticker: 'Change image',
      imageTooLarge: 'File larger than 5 MB',
      uploadFailed: 'Failed to upload image',
      addToHomework: 'Add to homework',
      cancel: 'Cancel',
      added: 'Word added to {{name}}’s dictionary',
      failed: 'Failed to add word',
      student: 'the student',
    },
  },
};

export default dict;
